import { gql } from 'apollo-angular';

export const TourQueries = {
	GET_ALL: gql`
		query getAllMyToursPref($userId: String!, $app: String!) {
			getAllMyToursPref(UserId: $userId, App: $app) {
				UserId
				App
				State
				LastUpdated
				TourId
			}
		}
	`,
	CREATE: gql`
		mutation createMyTourPref($app: String!, $userId: String!, $tourId: String!, $state: String!) {
			createMyTourPref(input: { App: $app, UserId: $userId, TourId: $tourId, State: $state }) {
				App
				UserId
				State
				LastUpdated
			}
		}
	`,
	UPDATE: gql`
		mutation updateMyTourPref($app: String!, $userId: String!, $tourId: String!, $state: String!) {
			updateMyTourPref(input: { App: $app, UserId: $userId, TourId: $tourId, State: $state }) {
				App
				UserId
				State
				LastUpdated
			}
		}
	`,
	DELETE: gql`
		mutation deleteMyTourPref($app: String!, $userId: String!, $tourId: String!) {
			deleteMyTourPref(UserId: $userId, App: $app, TourId: $tourId)
		}
	`
};
